import { render, staticRenderFns } from "./DAlert.vue?vue&type=template&id=0e612019&scoped=true&"
import script from "./DAlert.vue?vue&type=script&lang=js&"
export * from "./DAlert.vue?vue&type=script&lang=js&"
import style0 from "./DAlert.vue?vue&type=style&index=0&id=0e612019&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e612019",
  null
  
)

export default component.exports